import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { createElement } from '@wordpress/element';
import Edit from './edit';
import Save from './save';
import './style.scss';
import './editor.scss';

import logoImage from '../../assets/linear_logo_orange.png';

registerBlockType('linear/listings', {
    title: __('Linear listings', 'linear'),
    description: __('Display your Linear listings', 'linear'),
    category: 'widgets',
    icon: {
        src: createElement('img', {
            src: logoImage,
            style: { width: '20px', height: '20px' }
        })
    },
    supports: {
        html: false,
    },
    attributes: {
        attributesList: {
            type: "array",
            default: []
        },
        className: {
            type: 'string',
            default: ''
        }
    },
    edit: Edit,
    save: Save,
}); 